import React, { Suspense, lazy } from "react";
import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Navbar from "./components/Navbar";
import Footer from "./components/Footer";
import Home from "./pages/Home";
import About from "./pages/About";
import AboutPsychotherapy from "./pages/AboutPsychotherapy";
import Approach from "./pages/Approach";
import Services from "./pages/Services";
import Contact from "./pages/Contact";
import LegalNotice from "./pages/LegalNotice";
import PrivacyPolicy from "./pages/PrivacyPolicy";
import { Toaster } from "./components/ui/toaster";

// Chargée à la demande : le calendrier de réservation n'alourdit pas les
// autres pages.
const Booking = lazy(() => import("./pages/Booking"));

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Navbar />
        {/* Le fond pleine hauteur évite que le pied de page ne saute pendant le chargement. */}
        <Suspense fallback={<div className="min-h-screen bg-[#F5F3EB]" />}>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/qui-suis-je" element={<About />} />
            <Route path="/qui-suis-je/la-psychotherapie" element={<AboutPsychotherapy />} />
            <Route path="/mon-approche" element={<Approach />} />
            <Route path="/services" element={<Services />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/rendez-vous" element={<Booking />} />
            <Route path="/mentions-legales" element={<LegalNotice />} />
            <Route path="/politique-de-confidentialite" element={<PrivacyPolicy />} />
          </Routes>
        </Suspense>
        <Footer />
        <Toaster />
      </BrowserRouter>
    </div>
  );
}

export default App;
